import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Select, Store } from '@ngxs/store';
import { AttachmentActions } from '../state/attachments/actions';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem
} from '@angular/cdk/drag-drop';
import { Attachment } from '../shared/model/attachment';

@Component({
  selector: 'app-attachment',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss']
})
export class AttachmentComponent implements OnInit {
  @ViewChild('file', { static: true }) file;
  @Select(state => state.attachments.isLoading) isLoading$: Observable<boolean>;

  uploadFiles: Array<any> = [];
  emailAttachments: Array<Attachment> = [];
  deleteAttachments: Array<Attachment> = [];

  constructor(public dialogRef: MatDialogRef<AttachmentComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public store: Store) {}

  selectFiles(event) {
    this.uploadFiles = Object.values(event.target.files);
  }

  drop(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
    this.saveOrder();
  }

  remove(attachment: Attachment){
    this.deleteAttachments.push(attachment);
    this.saveOrder();
  }

  downloadFile(file) {
    this.store.dispatch(new AttachmentActions.DownloadFromS3(file));
  }

  upload() {
    // this.uploadFiles.forEach(file => {
      let s3upload = this.store.dispatch(new AttachmentActions.UploadToS3(this.uploadFiles, this.data.email.Id));

      s3upload.subscribe(()=>{
        this.saveOrder();
      })
    // });
    this.uploadFiles = [];
  }

  clearUploadList() {
    this.uploadFiles = [];
  }

  deleteDrop(event) {
    transferArrayItem(
      event.previousContainer.data,
      event.container.data,
      event.previousIndex,
      event.currentIndex
    );
    this.saveOrder();
  }

  saveOrder() {
    const emailAtt = this.emailAttachments.map((att, index) => {
      const newAtt = {...att};
      newAtt.Order = index;
      return newAtt;
    });
    this.store.dispatch(new AttachmentActions.UpdateAttachments(emailAtt));
    if (this.deleteAttachments.length) {
      this.store.dispatch(new AttachmentActions.DeleteAttachments(this.deleteAttachments));
      this.deleteAttachments = [];
    }
  }

  undoChanges() {
    this.store.selectSnapshot(state => {
      const { attachments } = state.attachments.attachments[this.data.email.Id];
      this.emailAttachments = [...attachments.sort((a, b) => a.Order - b.Order)];
      this.deleteAttachments = [];
    });
  }

  ngOnInit() {
    this.store.dispatch(new AttachmentActions.GetAttachments(this.data.email.Id));
    this.store
      .select(state => state.attachments.attachments)
      .subscribe(attachments => {
        console.log(attachments);
        if (attachments[this.data.email.Id]) {
          // need to spread the array on line 58 to create a local copy
          // store.select.subscribe gives a 'frozen' variable that doesn't work with the moveItemInArray() function

          this.emailAttachments = [...attachments[this.data.email.Id].attachmentList];
          this.emailAttachments.sort((a, b) => a.Order - b.Order);


          console.log(this.emailAttachments);
        }
      });
  }
}



